export default {"src":"/_next/static/media/photo_delate.f050502a.svg","height":24,"width":24};